// `config/routing-lists.json` (platform D159): the starting values of each list, loaded into the
// write database by a manager ("Load starting values" in Manage list), never by a migration.

import { z } from "zod";

const values = z.array(z.string().trim().min(1).max(200)).max(500);

export const routingListsSchema = z
  .object({
    "Work needed": values,
    "Inventory notes": values,
    Lead: values,
    "PE Order Status": values,
    "PE Order Assigned to": values,
  })
  .strict();
